interface ByePlayerSectionProps {
  seedNumber1: number;
  seedNumber2: number;
  player1: ByePlayer;
  player2: ByePlayer;
}
interface ByePlayer {
  firstName: string;
  lastName: string;
  isUserAlsoPlayer: boolean;
}

export const ByePlayerSection = ({
  seedNumber1,
  seedNumber2,
  player1,
  player2,
}: ByePlayerSectionProps) => {
  const showSeedNumber = seedNumber1 || seedNumber2;
  const showPlayerNames =
    player1.firstName || player1.lastName || player2.firstName || player2.lastName;
  if (!showSeedNumber || !showPlayerNames) return null;
  return (
    <div className='flex gap-1'>
      {showSeedNumber && showPlayerNames && (
        <div className='items-left flex flex-col text-base font-semibold text-gray-600'>
          <div
            className={`flex max-h-6 items-center ${player1.isUserAlsoPlayer ? 'text-leagues-500/90' : ''}`}
          >{`${seedNumber1}.`}</div>
          {seedNumber2 ? (
            <div
              className={`flex max-h-6 items-center ${player2.isUserAlsoPlayer ? 'text-leagues-500/90' : ''}`}
            >{`${seedNumber2}.`}</div>
          ) : null}
        </div>
      )}
      <div className='items-left flex flex-col text-base font-medium'>
        <PlayerName
          firstName={player1.firstName}
          lastName={player1.lastName}
          isUserAlsoPlayer={player1.isUserAlsoPlayer}
        />
        <PlayerName
          firstName={player2.firstName}
          lastName={player2.lastName}
          isUserAlsoPlayer={player2.isUserAlsoPlayer}
        />
      </div>
    </div>
  );
};

const PlayerName = ({ firstName, lastName, isUserAlsoPlayer }: ByePlayer) => {
  if (!firstName && !lastName) return null;

  return (
    <span className={`line-clamp-3 ${isUserAlsoPlayer ? 'text-leagues-500/90' : ''}`}>
      {`${firstName || ''} ${lastName || ''}`.trim()}
    </span>
  );
};
